import React from 'react';
import HtmlParse from 'html-react-parser';
import Dompurify from 'dompurify';

import styles from './HighlightedKeyword.module.css';
interface Props {
  content: string;
}

export const HighlightedKeyword = ({ content }: Props) => {
  return <div className={styles.container}>{content && HtmlParse(Dompurify.sanitize(content))}</div>;
};
